import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { adminLogin } from '../../api/news';

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await adminLogin(user.trim(), password);
      const to = location.state?.from || '/admin';
      navigate(to, { replace: true });
    } catch (err) {
      setError(err.message || 'Falha no login.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0e0e0e] px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-white p-8 shadow-xl"
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        <p className="text-[#C99A36] tracking-[0.35em] text-[11px] font-semibold mb-2">SETA ADMIN</p>
        <h1 className="text-2xl font-bold text-[#1a1a1a] mb-6">Entrar</h1>
        {error && <p className="mb-4 text-sm text-red-600">{error}</p>}
        <label className="block text-xs tracking-wide text-[#666] mb-1">Usuário</label>
        <input
          className="w-full border border-neutral-300 px-3 py-2 mb-4 text-sm outline-none focus:border-[#C99A36]"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          autoComplete="username"
          required
        />
        <label className="block text-xs tracking-wide text-[#666] mb-1">Senha</label>
        <input
          type="password"
          className="w-full border border-neutral-300 px-3 py-2 mb-6 text-sm outline-none focus:border-[#C99A36]"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#1a1a1a] text-white py-3 text-[12px] tracking-[0.2em] font-semibold hover:bg-[#C99A36] transition-colors disabled:opacity-60"
        >
          {loading ? 'ENTRANDO…' : 'ENTRAR'}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
